import React, { useEffect, useState } from "react";
import "./ProjectList.css";
import { data } from "../../Data/data"; // Ensure this contains category field
import { useLocation } from "react-router-dom";
import { Shimmer } from "react-shimmer";
import { Helmet } from "react-helmet";

function ProjectList() {
  const projectTop = useLocation();
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("ALL");
  const [filteredData, setFilteredData] = useState(data);

  useEffect(() => {
    // Simulating data loading delay
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [projectTop]);

  const categories = [
    "ALL",
    "CROWD FUNDING",
    "EDUCATION",
    "BUSINESS AUTOMATION",
    "HOTEL MANAGEMENT",
    "E-COMMERCE",
  ];

  // Update the filtered data when category changes
  useEffect(() => {
    if (selectedCategory === "ALL") {
      setFilteredData(data); // Show all projects
    } else {
      setFilteredData(
        data.filter((item) => item.category === selectedCategory)
      );
    }
  }, [selectedCategory]);

  // Filtering logic
  // const filteredData =
  //   selectedCategory === "All"
  //     ? data
  //     : data.filter((item) => item.category === selectedCategory);

  return (
    <>
      <Helmet>
        {/* Primary SEO */}
        <title>
          Spinecodes Projects | Crowd Funding, Education, Business Automation &
          More
        </title>
        <meta
          name="description"
          content="Explore Spinecodes' portfolio of projects including Crowd Funding apps, Education platforms, Business Automation software, Hotel Management apps, and E-Commerce solutions. View our latest digital innovations and spotlight works."
        />
        <meta
          name="keywords"
          content="Spinecodes Projects, Crowd Funding App Development, Education Apps, Business Automation Software, Hotel Management App, E-Commerce Solutions, Mobile App Development, Web Development, Digital Solutions, UX/UI Design, AI Applications"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.spinecodes.com/projects" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.spinecodes.com/projects" />
        <meta
          property="og:title"
          content="Spinecodes Projects | Digital Solutions Portfolio"
        />
        <meta
          property="og:description"
          content="Explore Spinecodes' portfolio of projects including Crowd Funding, Education, Business Automation, Hotel Management, and E-Commerce solutions."
        />
        <meta
          property="og:image"
          content="https://www.spinecodes.com/favicon.svg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Spinecodes Projects | Digital Solutions Portfolio"
        />
        <meta
          name="twitter:description"
          content="Explore Spinecodes' portfolio of projects including Crowd Funding, Education, Business Automation, Hotel Management, and E-Commerce solutions."
        />
        <meta
          name="twitter:image"
          content="https://www.spinecodes.com/favicon.svg"
        />
        <meta name="twitter:site" content="@SpineCodes" />
        <meta name="twitter:creator" content="@SpineCodes" />
      </Helmet>

      <div className="project-list">
        <h1>Spotlight Works</h1>

        {/* Category Buttons */}
        <div className="button-container">
          {categories.map((category, index) => (
            <button
              key={index}
              // className={project-bttn ${selectedCategory === category ? "active" : ""}}
              className={`project-bttn ${
                selectedCategory === category ? "active" : ""
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              {/* <div>
              <span>{category}</span>
              <span>{category}</span>
            </div> */}
              {category}
            </button>
          ))}
        </div>

        {/* Project Cards */}
        <div className="project-cards">
          {loading
            ? data.map((item) => (
                <div className="item-card" key={item.name}>
                  <div className="image-box">
                    <Shimmer
                      width={130}
                      height={150}
                      innerStyle={{
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                      }}
                      style={{ marginBottom: "10px" }}
                    />
                  </div>
                  <Shimmer
                    width={350}
                    height={30}
                    innerStyle={{ backgroundColor: "rgba(255, 255, 255, 0.5)" }}
                    style={{ marginBottom: "5px" }}
                  />
                  <Shimmer
                    width={350}
                    height={30}
                    innerStyle={{ backgroundColor: "rgba(255, 255, 255, 0.5)" }}
                    style={{ marginBottom: "5px" }}
                  />
                  <Shimmer
                    width={350}
                    height={30}
                    innerStyle={{ backgroundColor: "rgba(255, 255, 255, 0.5)" }}
                  />
                </div>
              ))
            : filteredData.map((item) => (
                <div className="item-card" key={item.name}>
                  <div className="image-box">
                    <img src={item.image} alt="Campaign" loading="lazy" />
                  </div>
                  <h6>{item.name}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
        </div>
      </div>
    </>
  );
}

export default ProjectList;
